/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { withRouter } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useSnackbar } from "notistack";
import { useIntl, FormattedMessage } from "react-intl";
import Dropdown from "react-bootstrap/Dropdown";
import objectPath from "object-path";

import { clearAll } from "../../../../../redux/features/login/loginSlice";
import { removeAll } from "../../../../../redux/features/stakeholder/stakeholderSlice";

import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { fetchToken } from "../../../../../redux/features/login/loginActions";
import { fetchNotifications } from "../../../../../redux/features/notifications/notificationActions";
// Material UI Icons
import { FilterList } from "@material-ui/icons";
import { SocketEventNames } from "../../../../../app/utils/socketEventNames";
import SocketService from "../../../../../services/SocketService";
import bgn from "./../../images/capture.png";
import PerfectScrollbar from "perfect-scrollbar";

function QuickActionsDropdown(props) {
  const bgImage = toAbsoluteUrl("/media/misc/bg-2.jpg");
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.quick-actions.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();

  const dispatch = useDispatch();
  const { stakeholders, currentStakeholder } = useSelector(
    (state) => state.stakeholder
  );
  const { person } = useSelector((state) => state.login);

  const changeAccount = async (s) => {
    try {
      if (s._id === currentStakeholder._id) {
        return;
      }
      dispatch(clearAll());
      dispatch(removeAll());
      sessionStorage.removeItem("persist:root");
      SocketService.emit({
        eventName: SocketEventNames.LEAVE,
        data: currentStakeholder._id,
      });
      const resp = await dispatch(fetchToken({ id: s._id }));
      dispatch(fetchNotifications(s._id));
      if (resp.data.stakeholder.active) {
        props.history.push("/stakeholder/cabinet/home");
        return;
      }
      props.history.push("/stakeholder/new");
    } catch (err) {
      enqueueSnackbar(
        intl.formatMessage({ id: err?.response?.data.message || err.message }),
        { variant: "error" }
      );
      console.error(err);
    }
  };

  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="left"
          overlay={
            // <Tooltip id="quick-actions-tooltip">
            //   <FormattedMessage id="my_accounts" />
            // </Tooltip>
            <div></div>
          }
        >
          <div className="topbar-item">
            <div
              className="btn btn-icon btn-clean btn-dropdown btn-lg mr-1"
              id="kt_quick_actions_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Adress-book2.svg"
                  )}
                  title=""
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop="down" alignRight>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_actions_panel_toggle"
          >
            <OverlayTrigger
              placement="bottom"
              overlay={
                // <Tooltip id="quick-actions-tooltip">
                //   <FormattedMessage id="my_accounts" />
                // </Tooltip>
                <div></div>
              }
            >
              <div className="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1">
                <span className="svg-icon svg-icon-xl">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Adress-book2.svg"
                    )}
                    title=" "
                  />
                </span>
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
            {/* begin: Head */}
            <div
              className="d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top "
              style={{ backgroundImage: `url(${bgn})` }}
            >
              <h3 className="text-white font-weight-bold font-size-5">
                <FormattedMessage id="my_accounts" />
              </h3>
            </div>
            {/* end: Head */}
            <div
              style={{
                maxHeight: "300px",
                position: "relative",
                overflow: "auto",
              }}
            >
              {stakeholders?.map((s) => (
                <div
                  className="row row-paddingless"
                  key={s._id}
                  onClick={() => changeAccount(s)}
                >
                  <div className="col-12">
                    <span className="d-block py-2 px-2 text-center bg-hover-light border-right border-bottom">
                      <div className="d-flex justify-content-between align-items-center">
                        {s._id === currentStakeholder._id ? (
                          <div className="col-md-2 d-flex justify-content-center">
                            <FilterList
                              style={{ fontSize: 30, color: "#499ecb" }}
                            />
                          </div>
                        ) : (
                          <div className="svg-icon svg-icon-3x svg-icon-success col-md-2"></div>
                        )}
                        <div className="col-md-10">
                          <span className="text-dark-75 d-block font-weight-bold font-size-h6 mt-2 mb-1">
                            {s.brandName ||
                              person?.name +
                                " " +
                                person?.surname +
                                " " +
                                person?.patronymic}
                          </span>
                          <span className="text-dark-50 d-block font-size-md">
                            {s?.voen ? (
                              <>
                                <FormattedMessage id="voen" />
                                {" : "}
                                {s?.voen}
                              </>
                            ) : (
                              s?.industrySubCategory?.name[intl.locale]
                            )}
                          </span>
                          <span className="text-dark-75 d-block text-dark-50 font-size-md">
                            <FormattedMessage id="label.status" />
                            {" : "}
                            <span
                              className={`label label-inline font-weight-bold ${
                                s.status === "NEW"
                                  ? "label-light-warning"
                                  : s.status === "IN PROGRESS"
                                  ? "label-light-primary"
                                  : s.status === "REJECTED"
                                  ? "label-light-danger"
                                  : "label-light-success"
                              }`}
                            >
                              <FormattedMessage
                                id={
                                  s.status === "NEW"
                                    ? "label.not_accepted"
                                    : s.status === "IN PROGRESS"
                                    ? "label.in_progress"
                                    : s.status === "REJECTED"
                                    ? "label.rejected"
                                    : "label.approved"
                                }
                              />
                            </span>
                          </span>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}

export default withRouter(QuickActionsDropdown);
